export const DELETE_ACCOUNT_PREPARE_BEGIN = "DELETE_ACCOUNT_PREPARE_BEGIN";
export const deleteAccountPrepareBegin = () => ({
  type: DELETE_ACCOUNT_PREPARE_BEGIN,
});

export const DELETE_ACCOUNT_PREPARE_END = "DELETE_ACCOUNT_PREPARE_END";
export const deleteAccountPrepareEnd = () => ({
  type: DELETE_ACCOUNT_PREPARE_END,
});

export const DELETE_ACCOUNT_FINALISE_BEGIN = "DELETE_ACCOUNT_FINALISE_BEGIN";
export const deleteAccountFinaliseBegin = (password, code) => ({
  type: DELETE_ACCOUNT_FINALISE_BEGIN,
  password,
  code,
});

export const DELETE_ACCOUNT_FINALISE_END = "DELETE_ACCOUNT_FINALISE_END";
export const deleteAccountFinaliseEnd = () => ({
  type: DELETE_ACCOUNT_FINALISE_END,
});
